import type { Application } from './Application';
import type { User } from './User';

export interface ProgramMembershipStats {
	programMembershipId: number;
	userDisplayName: string;
	userEmail: string;
	applicationsCount: number;
}

export interface ProgramMembershipSurveyStats {
	programMembershipId: number;
	created: boolean;
	completed: boolean;
}

export enum ProgramRole {
	GUEST = 'guest',
	USER = 'user',
	PROGRAM_ADMIN = 'program admin',
	PAIRS_COORDINATOR = 'pairs coordinator',
}
export interface ProgramMembership {
	id: number;
	role: ProgramRole;
	programId: number;
	userId: number;
	user: User;
	stats?: ProgramMembershipStats;
	surveyStats?: ProgramMembershipSurveyStats;
	applications?: Application[];
	coordinatePairs: Array<{
		pairId: number;
	}>;
}

export enum OrganizationRole {
	USER = 'user',
	ORGANIZATION_ADMIN = 'organization admin',
}

export interface OrganizationMembership {
	id: number;
	role: OrganizationRole;
	organizationId: number;
	userId: number;
	user?: User;
}
